import { scrollTo } from 'flos-react-cvi';
import React from 'react';

export function useScrollOnMount() {
    const targetRef = React.useRef<null | HTMLElement>(null);

    React.useEffect(() => {
        if (targetRef.current) {
            scrollTo(targetRef.current, {
                offset: 210
            });
        }
    }, []);

    return targetRef;
}
